import { useOptionalComputers, type ComputerContextValue } from "../../computers/context"
import type { PlatformCapabilities } from "../../platform/types"
import { getPlatformAdapter } from "../../platform/adapter"

type ComputerPathTarget = Pick<ComputerContextValue, "scope" | "state">

export function canUseNativeHostPathActions(capability: PlatformCapabilities["openHostPath"], computers: ComputerPathTarget | null): boolean {
    if (capability !== "available" || !computers) return false
    if (computers.scope !== computers.state.activeNodeId) return false
    const activeComputer = computers.state.computers.find((computer) => computer.nodeId === computers.state.activeNodeId)
    return activeComputer?.kind === "local"
}

export function useNativeHostPathActionsAvailable(): boolean {
    const computers = useOptionalComputers()
    return canUseNativeHostPathActions(getPlatformAdapter().capabilities.openHostPath, computers)
}
